import InputsTextfield from "./textfield";
import PopperJS from 'popper.js';
import { deepmerge } from 'utilities/merge';
import TimeLag from 'utilities/timelag';
export default class NumberComma extends InputsTextfield {
  lag: TimeLag;
  inputElement: HTMLInputElement;
  commaNumber: string;
  isShowTooltip: boolean = true;
  tooltipElement: HTMLElement;
  defaultOptions = {
    placement: 'auto',
    modifiers: {
      preventOverflow: {
        boundariesElement: 'window'
      },
      offset: {
        enabled: true,
        offset: '30px'
      }
    }
  }
  getPopperOptions(o = {}){
    return deepmerge(this.defaultOptions, o);
  }
  init(){
    super.init()
    this.lag = new TimeLag(() => { this.popper() }, 100)
    this.listenMount([this.onMountNumberComma]);
  }
  onMountNumberComma(){
    this.inputElement = this.querySelector('input') as HTMLInputElement;
    this.tooltipElement = this.querySelector('.tooltip-wrap') as HTMLElement;
    this.inputElement.addEventListener('focus', (e) => this.onFocus(e))
    this.inputElement.addEventListener('blur', (e) => this.onBlur(e))
  }
  onFocus(e){
    this.showTooltip();
    this.inputElement.addEventListener('input', this.onInput);
    this.update();
  }
  onBlur(e){
    this.hideTooltip();
    this.inputElement.removeEventListener('input', this.onInput);
    this.update();
  }
  showTooltip(){
    this.isShowTooltip = true;
    this.updateTooltip();
    this.lag.start();
  }
  hideTooltip(){
    this.isShowTooltip = false;
  }
  onInput(){
    this.updateTooltip();
  }
  updateTooltip(){
    let value = this.inputElement.value;
    this.commaNumber = Number(value).toLocaleString();
    this.update();
  }
  popper(){
    let popper = new PopperJS(
      this.inputElement,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
  }
}

riot.mixin("inputs.number-comma", NumberComma as riot.TagMixin)
